module.exports = new __parcel__URL__("EUROLogo.d27285e3.svg").toString();